import {create} from "zustand";

interface ApplicationState {
    interactionFlag: boolean;
    headerHeight: number;

    actions: {
        handleUserInteraction: () => void;
        setHeight: (height: number) => void;
    }
}

export const useApplicationStore = create<ApplicationState>()((set) => ({
    interactionFlag: false,
    headerHeight: 56,

    actions: {
        handleUserInteraction: () => set({interactionFlag: true}),
        setHeight: (height) => set({headerHeight: height}),
    }
}));
